const apiPort = (process.env.NODE_ENV === "development" || process.env.REACT_APP_LOCAL_DB === "true") ? "3000" : window.location.port === "9999" ? "10444" : (window.location.port === "10000" ? "10445" : "10443");

export const API_URL = `${window.location.protocol}//${window.location.hostname}:${apiPort}`;
export const SHOP_URL = `${window.location.protocol}//${window.location.hostname}:8080/shop`
export const LOCAL_CLOUD = `${API_URL}/images/${sessionStorage.getItem('clientId')}`
export const CONSOLE_CLOUD = `${API_URL}/images/console`
// export const WKF_BASE_URL = `https://portal.retail24.pl: 9999`
export const WKF_API_BASE_URL = `https://portal.retail24.pl:10444`
export const WKF_BASE_URL = `https://portal.retail24.pl`



